import {MenuItemModel} from './menu-item.model';

export class MenuCategoryModel {
  id: number;
  menu_section_id: number;
  title: string;
  hotel_id: number;
  menu_item_id: number;
  menu_items: MenuItemModel[];

  constructor(id = 0,
              menu_section_id = 0,
              title = '',
              hotel_id = 0,
              menu_item_id = 0) {
    this.id = id;
    this.menu_section_id = menu_section_id;
    this.title = title;
    this.hotel_id = hotel_id;
    this.menu_item_id = menu_item_id;
  }
}
